module.exports = __webpack_public_path__ + "a2cd31aa9d2fceb1b8840384ffdcf7aa.svg";